export default (list = [], thisTemplate, surveysLabel) => {
  list = list.filter(ele => {
    let identifer = ele?.schemaIdentifier || '';
    let [, productName, eventTypeCategory] = identifer.split('.');
    return (
      ele.active &&
      (thisTemplate?.campaignOccurrenceType === 'ON_EVENT'
        ? eventTypeCategory === thisTemplate?.eventTypeCategory &&
          productName === thisTemplate?.productName
        : ele?.productName === thisTemplate?.productName) &&
      (thisTemplate.productType === 'LIST' ? (thisTemplate?.segmentedListId ? (ele?.segmentedListId === thisTemplate?.segmentedListId) : (ele?.subscriberListId === thisTemplate?.subscriberListId)) : true)
    );
  });
  return {
    dataType: 'Surveys',
    key: 'surveys',
    name: surveysLabel,
    surveyMenuOptions: list.map(item => {
      return {
        displayName: item.name,
        value: `${item.surveyUrl}/{{surveyRecipientIdentifier}}`
      };
    })
  };
};
